export default function handleNav() {

    const navToggle = document.querySelector('.header__nav-toggle')
    let navTarget = document.querySelector('.header__nav')

    navToggle.onclick = () => {
        let expanded = navToggle.getAttribute('aria-expanded') === 'true'
        navToggle.setAttribute('aria-expanded', !expanded)
        navTarget.hidden = expanded
    }

}
